import { Component, ElementRef, Input } from '@angular/core';

@Component({
    selector: 'tt-option',
    template: '<ng-content></ng-content>',
    standalone: false,
})
export class SelectOptionComponent {
    @Input() public ttValue: string | number | boolean | null = '';

    constructor(private elementRef: ElementRef<HTMLElement>) {}

    public get label(): string {
        return this.elementRef.nativeElement.textContent?.trim() ?? '';
    }
}
